import {
  dadataToken
} from './const';

export function initNameSuggestions(tagName) {
  $(document).ready(function () {

    const elem = $(tagName);

    elem.suggestions({
      token: dadataToken,
      type: 'NAME',
      params: {
        parts: ['NAME']
      },
      hint: false,
      scrollOnFocus: false
    });
  });
}

export function initSurnameSuggestions(tagName) {
  $(document).ready(function () {

    const elem = $(tagName);

    elem.suggestions({
      token: dadataToken,
      type: 'NAME',
      params: {
        parts: ['SURNAME']
      },
      hint: false,
      scrollOnFocus: false
    });
  });
}

export function initPatronymicSuggestions(tagName) {
  $(document).ready(function () {

    const elem = $(tagName);

    elem.suggestions({
      token: dadataToken,
      type: 'NAME',
      params: {
        parts: ['PATRONYMIC']
      },
      hint: false,
      scrollOnFocus: false
    });
  });
}


export function initFullnameSuggestions(tagName) {

  $(document).ready(function () {

    const elem = $(tagName);

    elem.suggestions({
      token: dadataToken,
      type: 'NAME',
      hint: false,
      scrollOnFocus: false
    });
  });
}

export function initCheckoutNameSuggestions() {

  $(document).ready(function () {

    const $nameAndSurname = $('#fullname');
    const $patronymic = $('#patronymic');

    $nameAndSurname.suggestions({
      token: dadataToken,
      type: 'NAME',
      hint: false,
      scrollOnFocus: false,
      onSelect: onSelectFullname,
      onSelectNothing: clearFullnameSelected
    });

    $patronymic.suggestions({
      token: dadataToken,
      type: 'NAME',
      params: {
        parts: ['PATRONYMIC']
      },
      hint: false,
      scrollOnFocus: false,
      onSelect: onSelectPatronymic,
      onSelectNothing: clearPatronymicSelected
    });
  });
}

function onSelectFullname(suggestion) {
  decomposeName(suggestion);
}

function decomposeName(suggestion) {
  let fullname = suggestion.data;
  $('#surname-part').val(fullname.surname);
  $('#name-part').val(fullname.name);
  $('#patronymic-part').val(fullname.patronymic);
}

function clearFullnameSelected() {
  $('#surname-part').val('');
  $('#name-part').val('');
}

function onSelectPatronymic(suggestion) {
  let patronymic = suggestion.data.patronymic;
  $('#patronymic-part').val(patronymic);
}

function clearPatronymicSelected() {
  $('#patronymic-part').val('');
}
